import React, { useState,useEffect } from "react";
import { Button, Box, Typography, Stack } from "@mui/material";
import { usePricing } from "../../contexts/PricingContext";
import EditableList from "../../components/Custom/EditableList";
import FuncionarioList from "../../components/Custom/FuncionarioList";
import { opcoesCustosFixos, opcoesCustosVariaveis } from "../../constants/opcoesCustos";
import { useCompany } from "../../contexts/CompanyContext"
import {savePricingStepper1Data} from "../../services/pricingService"
import { findCompany } from "../../services/companyService";
import PropTypes from "prop-types";

const steps = ["Custos Fixos", "Custos Variáveis", "Quadro de Funcionários"];

const StepperEtapa1 = ({ onFinish }) => {
  const [activeStep, setActiveStep] = useState(0);
  const { formData, updateFormData } = usePricing();
  const {company} = useCompany()

  useEffect(() => {
    async function fetchData() {
      if (company?.companyId) {
        const dados = await findCompany(company.companyId);
        if (dados) {
          updateFormData("custosFixos", dados.fixedCosts ? Object.values(dados.fixedCosts) : []);
          updateFormData("custosVariaveis", dados.variableCosts ? Object.values(dados.variableCosts) : []);
          updateFormData("funcionarios", dados.employee ? Object.values(dados.employee) : []);
        }
      }
    }
    fetchData();
    // eslint-disable-next-line
  }, [company?.companyId]);

  const handleNext = () => {
    if (activeStep === steps.length - 1) {
      savePricingStepper1Data(company.companyId,formData)
      onFinish();
    } else {
      setActiveStep((prev) => prev + 1);
    }
  };

  const handleBack = () => setActiveStep((prev) => Math.max(prev - 1, 0));

  const calcularTotal = (lista, campoValor = "valor") => {
    if (!Array.isArray(lista)) return 0;
    return lista.reduce((acc, item) => acc + (parseFloat(item[campoValor]) || 0), 0);
  };

  return (
    <Box sx={{ flex: 1, overflowY: "auto", px: 3, pt: 4 }}>
      {activeStep === 0 && (
        <>
          <EditableList
            items={formData.custosFixos}
            onChange={(next) => updateFormData("custosFixos", next)}
            descricaoLabel="Descrição do custo fixo"
            valorLabel="Valor mensal"
            descricaoMode="autocomplete"
            descricaoOptions={opcoesCustosFixos}
            descricaoFreeSolo
          />
          <Typography variant="subtitle1" sx={{ mt: 2 }}>
            Total: {calcularTotal(formData.custosFixos).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}
          </Typography>
        </>
      )}
      {activeStep === 1 && (
        <>
          <EditableList
            items={formData.custosVariaveis}
            onChange={(next) => updateFormData("custosVariaveis", next)}
            descricaoLabel="Descrição do custo variável"
            valorLabel="Valor"
            descricaoMode="autocomplete"
            descricaoOptions={opcoesCustosVariaveis}
            descricaoFreeSolo
          />
          <Typography variant="subtitle1" sx={{ mt: 2 }}>
            Total: {calcularTotal(formData.custosVariaveis).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}
          </Typography>
        </>
      )}
      {activeStep === 2 && (
        <>
          <FuncionarioList
            items={formData.funcionarios}
            onChange={(next) => updateFormData("funcionarios", next)}
          />
          <Typography variant="subtitle1" sx={{ mt: 2 }}>
            Total: {calcularTotal(formData.funcionarios, "salario").toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}
          </Typography>
        </>
      )}

      <Stack direction="row" spacing={2} mt={3}>
        <Button variant="outlined" onClick={handleBack} disabled={activeStep === 0}>Voltar</Button>
        <Button variant="contained" onClick={handleNext}>
          {activeStep === steps.length - 1 ? "Finalizar Etapa 1" : "Próximo"}
        </Button>
      </Stack>
    </Box>
  );
};


StepperEtapa1.propTypes = {
  onFinish: PropTypes.object.isRequired
};

export default StepperEtapa1;